import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AccountService from '../../services/account.service';
import PlansService from '../../services/plans.service';
import { Modal, Button, Select, MenuItem, FormControl, InputLabel, Box, Typography } from '@mui/material';

const MarkAsPaidModal = ({ open, onClose, accountId, onSuccess }) => {
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('');

  useEffect(() => {
    if (open) {
      // Fetch plans when modal opens
      PlansService.getAll()
        .then((response) => {
          setPlans(response.data.plans);
        })
        .catch((error) => {
          console.error('Error fetching plans:', error);
        });
    }
  }, [open]);

  const handleSave = () => {
    AccountService.markAsPaid(accountId, selectedPlan)
      .then(() => {
        onSuccess();
        onClose();
      })
      .catch((error) => {
        console.error('Error marking account as paid:', error);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 1
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Mark Account as Paid
        </Typography>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Select Plan</InputLabel>
          <Select value={selectedPlan} label="Select Plan" onChange={(e) => setSelectedPlan(e.target.value)}>
            {plans.map((plan) => (
              <MenuItem key={plan.id} value={plan.id}>
                {plan.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave} disabled={!selectedPlan}>
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

MarkAsPaidModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired
};

export default MarkAsPaidModal;
